export function unbreakText(text: string) {
  return text.replace(/ /g, '\u00a0');
}
